import APIService from "./APIService";

/**
 * Service for handling all reports-related API operations
 */
const ReportsAPI = {
  /**
   * Get email reports for a user within a specific date range
   * @param {string} userUuid - The user ID
   * @param {string} startDate - Start date in ISO date-time format (YYYY-MM-DDTHH:mm:ss)
   * @param {string} endDate - End date in ISO date-time format (YYYY-MM-DDTHH:mm:ss)
   * @returns {Promise} - Promise that resolves with the API response containing email reports
   */
  getEmailReportsByUserUuidAndDateRange: async (
    userUuid,
    startDate,
    endDate
  ) => {
    console.log(
      `[ReportsAPI] Getting email reports for user ${userUuid} from ${startDate} to ${endDate}`
    );

    try {
      // Construct the endpoint with query parameters
      const endpoint = `/api/v1/app/reports/emails/user/${userUuid}/date-range?startDate=${encodeURIComponent(
        startDate
      )}&endDate=${encodeURIComponent(endDate)}`;

      const response = await APIService.get(endpoint);

      console.log(
        `[ReportsAPI] Email reports retrieved successfully:`,
        response
      );
      return response;
    } catch (error) {
      console.error(`[ReportsAPI] Error getting email reports:`, error);
      throw new Error(`Failed to retrieve email reports: ${error.message}`);
    }
  },

  /**
   * Get all email reports for a user (without date filtering)
   * @param {string} userUuid - The user ID
   * @returns {Promise} - Promise that resolves with the API response containing all email reports
   */
  getAllEmailReportsByUserUuid: async (userUuid) => {
    console.log(`[ReportsAPI] Getting all email reports for user ${userUuid}`);

    try {
      const endpoint = `/api/v1/app/reports/emails/user/${userUuid}`;

      const response = await APIService.get(endpoint);

      console.log(
        `[ReportsAPI] All email reports retrieved successfully:`,
        response
      );
      return response;
    } catch (error) {
      console.error(`[ReportsAPI] Error getting all email reports:`, error);
      throw new Error(`Failed to retrieve all email reports: ${error.message}`);
    }
  },
};

export default ReportsAPI;
